import { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import { buyerFaqs } from '../data/comparisonPageContent';

const ComparisonFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="space-y-4">
      {buyerFaqs.map((faq, index) => (
        <div key={faq.question} className="overflow-hidden rounded-2xl border border-slate-800 bg-slate-900">
          <button type="button" onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between gap-5 px-6 py-5 text-left">
            <span className="text-lg font-semibold text-white">{faq.question}</span>
            <SafeIcon name={openIndex === index ? 'ChevronUp' : 'ChevronDown'} className="shrink-0 text-slate-400" />
          </button>
          {openIndex === index && <p className="px-6 pb-6 leading-relaxed text-slate-400">{faq.answer}</p>}
        </div>
      ))}
    </div>
  );
};

export default ComparisonFAQ;